import { useState, useEffect } from 'react';

export function useLoading<T>(data: T, delayMs = 600): { loading: boolean; value: T } {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  return { loading, value: data };
}